import { locales, defaultLocale } from "@/i18n/config";

/**
 * Where to send someone after they sign in or change their password, in the
 * language they are already reading.
 *
 * TWO COPIES OF THIS EXISTED and both had the same bug: a hardcoded locale list
 * that omitted `de` and `tr`. The login page's copy sent German and Turkish
 * users to /jobs instead of /de/jobs (an extra redirect), and the auth callback's
 * copy was worse: with next=/de/jobs it produced /de/de/jobs, which is not a
 * page. Derived from the locale config now, so adding a locale cannot reopen it.
 *
 * Client-side only: it reads window.location.
 */
export function localeFromPathname(pathname: string): string | null {
  const first = pathname.split("/")[1];
  return (locales as readonly string[]).includes(first) ? first : null;
}

/** `/it/jobs` on an Italian page, `/jobs` on an English one. */
export function jobsPathForCurrentLocale(): string {
  if (typeof window === "undefined") return "/jobs";
  const locale = localeFromPathname(window.location.pathname);
  return locale && locale !== defaultLocale ? `/${locale}/jobs` : "/jobs";
}
